export const actionTypeDict = {
  blockAirfindUser: "Usuario bloqueado",
  banAirfindUser: "Usuario prohibido",
  unblockAirfindUser: "Usuario desbloqueado",
  unbanAirfindUser: "Usuario liberado",
  viewAirfindUserTransaction: "Transacciones de usuario vistas",
  editAirfindUserInfo: "Informacion de usuario actualizada",
  transferAirfindUserInfo: "Usuario transferido",
  supportTicketClosed: "Ticket de soporte cerrado",
  enableOperator: "Operador habilitado",
  disableOperator: "Operador deshabilitado",
  editOperatorInfo: "Información de operador actualizada",
  addOperatorInfo: "Operador fue creado",
  null: "Informacion de log",
}